import { compareFn } from "utils/common";

const postCloseStrategiesValues = [
  "SUPPLIER LOANS STRATEGY",
  "SUPPLIER EQUITY STRATEGY",
  "SUPPLIER CONSIGNMENT STRATEGY",
  "ACCOUNTS RECEIVABLE LOAN STRATEGY",
  "MEZZANINE FINANCE STRATEGY",
  "PLANT AND EQUIPMENT SELL OFF STRATEGY",
  "PLANT AND EQUIPMENT REFINANCE STRATEGY",
  "F.F.E LIQUIDATION STRATEGY",
  "IP SELL-OFF STRATEGY",
  "MANAGER EQUITY STRATEGY",
  "INVESTOR BUY IN STRATEGY",
  "THE SEE-SAW STRATEGY",
  "INVENTORY SELL OFF STRATEGY",
  "STOCK SELL OFF STRATEGY",
  "SUB LEASE TO 3RD PARTY STRATEGY",
  "RECURRING RUN UP STRATEGY",
  "CAPITAL RAISE STRATEGY",
  "DEBT RESTRUCTURE STRATEGY",
  "GRANT WRITING STRATEGY",
  "OTHER",
];
const postCloseStrategiesDesc = [
  "SUPPLIER TO EXTEND CREDIT TERMS OVER X PERIOD OR ALLOW FREE CASH TO PAY BACK BUY IN",
  "OFFER SUPPLIER EQUITY IN BUSINESS IN EXCHANGE FOR CASH AND BETTER SUPPLY TERMS",
  "ASK SUPPLIER TO GIVE YOU CONSIGNMENT TERMS",
  "GET A LOAN OVER THE A/R THAT COMING IN",
  "Hybrid financing of debt and equity",
  "SELL OFF UNWANTED PLANT OR EQUIPMENT",
  "Re-finance plant and equipment loans to lower cost",
  "SELLING OFF FURNITURE, FIXTURE AND FITTINGS",
  "Sell parts of the IP in the business off",
  "Having the manger in the business buy in or multiple team members",
  "SELLING A SHARE OF THE BUSINESS",
  "INVESTOR BUY IN ON THE JOURNEY TO A VALUATION TIPPING POINTS TO EQUITY WITH ZERO DEBT",
  "SELL INVENTORY TO OTHER COMPANIES",
  "SELL STOCK TO OTHER COMPANIES",
  "SUBLET PART OF OFFICE ",
  "GETTING ANY RECURRING CUSTOMERS TO PAY UP FRONT AND RECIEVE DISCOUNT",
  "RAISE CAPITAL FROM INVESTORS IMMEDIATELY ON CLOSING",
  "Re-structure any debt in company after assumption to lower repayments",
  "APPLY FOR GRANTS AVAILABLE ",
  "SELECT THIS OPTION TO ADD YOUR OWN CUSTOM STRATEGY",
];

export const postCloseStrategies = postCloseStrategiesValues
  .map((i, idx) => ({
    value: i,
    description: postCloseStrategiesDesc[idx],
    id: i,
    label: i,
    inputText: "",
  }))
  .sort(compareFn);
